"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = void 0;
var Utils_1 = require("./Utils");
var Route = (function () {
    function Route(components, options) {
        this.components = [];
        this.components = Array.isArray(components) ? components : [components];
        this.id = options.id;
        this.path = options.path.replace(/\/$/, "");
        this.regExp = Utils_1.pathToRegexp(options.path);
        this.params = parseParams(options.path);
        this.policies = options.policies || [];
        this.before = options.before;
        this.after = options.after;
    }
    Route.prototype.base = function (path) {
        if (path === void 0) { path = ""; }
        this.regExp = Utils_1.pathToRegexp(path + this.path);
        return this;
    };
    Route.prototype.match = function (path) {
        return this.regExp.exec(path);
    };
    return Route;
}());
exports.Route = Route;
function parseParams(path) {
    return path.split("/").reduce(function (list, next) {
        if (next.match(/:/)) {
            list.push({
                name: next.replace(":", ""),
                value: undefined
            });
        }
        return list;
    }, []);
}
